<template>
<div>
    <!-- <TheNavigationPanel/> -->
    <v-container>
        <div :class="{'mx-9':$vuetify.breakpoint.lgAndUp, 'mx-0': $vuetify.breakpoint.mdAndDown}">
        <v-toolbar flat color="#F0FFEA" height="30" >
            <v-toolbar-title style="color:#08911B" class="headline">Claims</v-toolbar-title>
        </v-toolbar>
        <v-card class="my-5" flat>
            <!-- claims -->
        <template>
            <v-data-table
            :headers="claimHeaders"
            :items="Claims"
            :class="elevation-1"
            class="px-5"
            :items-per-page="5"
            :search="search"
            :loading="loader"
            no-data-text="No Claims Available"
            >
            <template  v-slot:top>
                <v-toolbar flat color="white">
                    <v-text-field
                        v-model="searchClaims"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                        color="#08911B"
                        style="width:20%"
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-select outlined label="claims status..." color="#08911B" :items="claimStatus" v-model="selectClaimStatus" class="mt-8" dense style="width:10%" @change="onChange($event)">

                    </v-select>
                </v-toolbar>
                <!-- <v-divider class=""></v-divider> -->
                <br><br>
            </template>
            <template v-slot:item.policy_holder_claim_amount="{ item }">
                <span>&#8358;{{item.policy_holder_claim_amount}}</span>
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon
                    style="color:#B45C5C; cursor: pointer;"
                    @click="getClaim(item.id)"
                    >
                    mdi-chevron-right
                </v-icon>
            </template>
            </v-data-table>
        </template>
        </v-card>
        
    </div>
    </v-container>

</div>
   
</template>
<script>
    // import TheNavigationPanel from '../components/TheNavigationPanel';

    export default {
        name: 'communityMembers',
        components: {
            // TheNavigationPanel,
        },

        data: () => ({
            searchClaims:'',
            selectClaimStatus:'Reported',
            selectClaimStatus:'',
            claimHeaders: [
                {
                text: 'Policy Holder',
                align: 'left',
                sortable: true,
                value: 'name',
                class:'font-weight-black'
                },
                {text: 'Policy Number', value:'policy_number', sortable:false},
                {text: 'Claim Amount', value:'policy_holder_claim_amount', sortable:false},
                {text:'Status', value:'status', sortable: false},
                { text: '', value: 'action', sortable: false },
            ],
           loader:false,
            claimStatus:['All', 'Reported','Loss Assessor Reccomended Amount','Recommendation Accepted', 'Recommendation Rejected ', 'Consultant Recommended Amount', 'Claims Paid', 'Declined']
        }),
        computed:{
            Claims(){
                let trans = this.$store.state.claims.claims
                for(let j=0; j<trans.length; j++){
                    trans[j].policy_holder_claim_amount = parseFloat(trans[j].policy_holder_claim_amount).toFixed(2);
                    trans[j].policy_holder_claim_amount = trans[j].policy_holder_claim_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                
                }
                return trans
            }
        },
        methods:{ 
            onChange(event) {
                this.loader=true
                if (event === 'All'){
                     this.$store.dispatch("getClaims")
                    .then(()=>{
                        this.loader=false
                    })
                    .catch(()=>{
                     this.loader =false
                    });
                }else{
                    this.$store.dispatch("getClaimsFilter", {status:event})
                    .then(()=>{
                        this.loader =false
                    })
                    .catch(()=>{
                        this.loader=false
                    }); 
                }
            },
            getClaim(id){
                this.$store.dispatch("ViewClaim", id)
                .then((success)=>{
                    this.$router.push(`/claims/${success.claim[0].policy_holder}`)
                })
                .catch((error)=>{
                    console.log(error)
                })
            },
        },
        created(){
        this.$store.dispatch("getClaims")
        .then(()=>{
        })
        .catch(()=>{
        });
        }
    }
</script>